import axios from "axios"
const baseUrl = process.env.REACT_APP_GENERAL_API_URL

export const allBlogs = () => {
    let config = {
        method: 'get',
        url: `${baseUrl}/api/blog/getAllPosts`
    };

    const res = axios.request(config)
        .then((response) => {
            return response.data
        })
        .catch((error) => {
            console.log("error in allBlogs: ", error);
            return error.response
        });
    return res;
}
